import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import PipelineBoard from "@/components/PipelineBoard";
import EmptyState from "@/components/EmptyState";
import { getMyApplications } from "@/lib/afritask";

export default function Applications() {
  const { me } = useOutletContext();
  const [pipeline, setPipeline] = useState({
    in_progress: [],
    submitted: [],
    ranked: [],
    won: [],
  });
  const [stats, setStats] = useState({ tasks_completed_count: 0 });

  const load = async () => {
    try {
      const mine = await getMyApplications();
      setPipeline(mine.pipeline);
      setStats(mine.stats);
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    if (me) load();
  }, [me]);

  const totalEntries = Object.values(pipeline).reduce(
    (a, b) => a + b.length,
    0
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold tracking-tight text-neutral-900 sm:text-2xl">
          My applications
        </h1>
      </div>

      {totalEntries === 0 ? (
        <EmptyState
          art="signpost"
          title="You haven't entered any rounds yet"
          body="Enter a challenge round from the tasks list to start building your pipeline."
          ctaLabel="Browse tasks"
          ctaTo="/app/tasks"
          testid="applications-empty-state"
        />
      ) : (
        <PipelineBoard
          available={null}
          pipeline={pipeline}
          completedCount={stats.tasks_completed_count}
          hideEmptyMiddleCols
          hideEmptyPaidCol
          hideHeader
        />
      )}
    </div>
  );
}
